// jwt (new)
export const AUTH_JWT_HEADER_ACCESS_TOKEN   = 'Gd-Access-Token'
export const AUTH_JWT_ARGS_ACCESS_TOKEN     = 'Gd-Access-Token'
export const AUTH_JWT_URL_ACCESS_TOKEN_KEY  = 'accessToken'
export const AUTH_JWT_LOCAL_STORAGE_KEY     = "accessToken"

// Token (old)
export const AUTH_TOKEN_SESSION_STORAGE_KEY     = 'authToken'
export const AUTH_TOKEN_LOCAL_STORAGE_KEY       = 'authToken'

export enum AuthMode {
    // TOKEN_OLD       = 'token',      // mobile old
    SESSION         = 'session',    // web old
    JWT             = 'jwt-token',  // new universal

    // AUTH_TOKEN_SESSION          = 'auth-token-session',     // mobile , authToken is session
    AUTH_TOKEN_LOCAL_STORAGE    = 'auth-token-ls',          // web old teams - authToken shouldbe saved in LocalStorage
}

// export enum AuthTokenStorage {
//     SESSION     = 'session-storage',
//     LOCAL       = 'local-storage'
// }
